module.exports = __webpack_public_path__ + "img/p7.34a652e0.png";